<template>
    <div class="order-extend">
        <v-container fluid>
            <v-row>
                <v-col cols="12" md="6" class="py-0">
                    <a :href="`/products/${orderData.productID}`" class="title grey--text darken-3" target="_blank">
                        {{ orderData.productName }}
                    </a>
                </v-col>
                <v-col cols="12" offset-md="3" md="3" class="py-4 py-md-0">
                    <v-select
                        class="pt-0 mt-0"
                        v-model="orderData.statusID"
                        :label="statusField.label"
                        item-text="name"
                        item-value="id"
                        :items="statusField.items"
                        color="orange lighten-2"
                        item-color="orange lighten-2"
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <price-info :order="orderData" @value-change="orderChange"></price-info>
                </v-col>
                <v-col cols="12" v-if="orderData.commercialPolicies && Object.keys(orderData.commercialPolicies).length">
                    <commercial-policy-info :order="orderData"></commercial-policy-info>
                </v-col>
                <v-col cols="12">
                    <delivery-info :order="orderData" @value-change="orderChange"></delivery-info>
                </v-col>
                <v-col cols="12" v-if="contracts && contracts.length">
                    <contract-info :order="orderData" @value-change="orderChange" :contracts="contracts"></contract-info>
                </v-col>
                <v-col cols="12">
                    <buyer-info :order="orderData"></buyer-info>
                </v-col>
                <v-col cols="12">
                    <notes-info :order="orderData" @value-change="orderChange"></notes-info>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-btn color="main--yellow" dark depressed @click="save" :disabled="disabledUpdate">
                        {{ $t('save') }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text class="red--text" @click="remove">
                        {{ $t('remove') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import BuyerInfo from "./ExtendBuyerInfo"
    import CommercialPolicyInfo from "./ExtendCommercialPolicyInfo"
    import ContractInfo from "./ExtendContractInfo"
    import DeliveryInfo from "./ExtendDeliveryInfo"
    import PriceInfo from "./ExtendPriceInfo"
    import NotesInfo from "./ExtendNotesInfo"

    export default {
        name: "SalesDataExtend",
        props: ['order', 'fields', 'contracts'],
        data() {
            return {
                orderData: {},
                contractFile: null,
            }
        },
        components:{
            BuyerInfo,
            ContractInfo,
            CommercialPolicyInfo,
            DeliveryInfo,
            NotesInfo,
            PriceInfo
        },
        computed: {
            disabledUpdate() {
                let disabled = false;

                if(!this.orderData.quantity || !this.orderData.address || !this.orderData.price) {
                    disabled = true;
                }

                return disabled;
            },
            statusField() {
                const field = this.fields.find(item => item.name === 'statusID');

                return field || {};
            }
        },
        methods: {
            initOrderData() {
                this.orderData = this.order;
            },
            productNds () {
                this.orderData.withNds.map(item => {
                    if (item.checked === true) {
                        if (item.title) {
                            this.ndsPrice = item.title;
                        }
                    }
                });
                return this.ndsPrice;
            },
            remove() {
                this.$emit('remove', this.orderData);
            },
            save() {
                this.$emit('save', this.orderData);
            },
            orderChange(data) {
                const key = data.key;
                this.orderData[key] = data.value;
            }
        },
        watch: {
            order() {
                this.initOrderData();
            }
        },
        created() {
            this.initOrderData();
        }
    }
</script>
